<template>
  <div class="vx-row">
    <div class="vx-col md:w-1/1 w-full">
      <div class="con-vs-alert con-vs-alert-danger" v-show="!data.id">
        <div class="vs-alert text-center">
          Atenção: Somente a situação, ordem e desconto poderá ser editada depois que o plano for criado.<br>
          Nenhuma outra informação poderá ser alterada após criar o plano.
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col md:w-6/12 w-full">
          <vs-input class="w-full" label="Nome" v-model="data.name" autofocus :disabled="data.id" />
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col md:w-6/12 w-full">
          <vs-select v-model="data.product_id" label="Produto" class="w-full" :disabled="data.id">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in products" />
          </vs-select>
        </div>
      </div>

      <div class="vx-row mt-4" v-show="data.product_id === 1">
        <div class="vx-col md:w-6/12 w-full">
          <vs-select v-model="data.recurring" label="Recorrente" class="w-full" :disabled="data.id">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in recurring" />
          </vs-select>
        </div>
      </div>

      <div class="vx-row mt-4" v-show="data.product_id === 1 && data.recurring === 'YES'">
        <div class="vx-col md:w-6/12 w-full">
          <div>Usar ponto para separar os centavos, ex. 10.99</div>
          <vs-input class="w-full" label="Adesão" v-model="data.setup_fee" :disabled="data.id" />
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col md:w-6/12 w-full">
          <div>Usar ponto para separar os centavos, ex. 10.99</div>
          <vs-input class="w-full" label="Recorrente" v-model="data.fixed_price" v-show="data.recurring === 'YES'" :disabled="data.id" />
          <vs-input class="w-full" label="Adesão" v-model="data.fixed_price" v-show="data.recurring === 'NO'" :disabled="data.id" />
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col md:w-6/12 w-full">
          <vs-select v-model="data.status" label="Situação" class="w-full">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in status" />
          </vs-select>
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col md:w-6/12 w-full">
          <vs-select v-model="data.status_new_checkout" label="Situação Novo Checkout" class="w-full">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in statusNewCheckout" />
          </vs-select>
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col md:w-6/12 w-full">
          <vs-select v-model="data.currency_code" label="Moeda" class="w-full" :disabled="data.id">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in currencies" />
          </vs-select>
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col md:w-6/12 w-full">
          <vs-select v-model="data.interval_unit" label="Intervalo" class="w-full" :disabled="data.id">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in intervals" />
          </vs-select>
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col md:w-6/12 w-full">
          <vs-input class="w-full" label="Periodicidade" type="number" v-model="data.interval_count"
                    min="0" :disabled="data.id" />
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col md:w-6/12 w-full">
          <vs-input
            class="w-full"
            label="Ordem"
            v-model="data.sort"
            type="number"
            placeholder="Numérico começando de 0"
          />
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col md:w-6/12 w-full">
          <div>Usar ponto para separar os centavos, ex. 10.99</div>
          <vs-input class="w-full" label="Desconto" v-model="data.discount" />
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col md:w-6/12 w-full text-center">
          <vs-button class="mt-4" icon-pack="feather" icon="icon icon-file" @click="save">Salvar</vs-button>
        </div>
        <div class="vx-col md:w-6/12 w-full text-right">
          <vs-button class="mt-4" icon-pack="feather" color="danger" @click="$router.push('/planos')"
          >Cancelar
          </vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import {ptBR} from 'vuejs-datepicker/dist/locale'

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      ptBR,
      data: {
        product_id: 1,
        name: null,
        recurring: 'NO',
        status: 'HIDDEN',
        status_new_checkout: 'INACTIVE',
        sort: '999',
        discount: '',
        fixed_price: '',
        interval_count: '',
        interval_unit: 'MONTH',
        setup_fee: '0',
        currency_code: 'BRL',
      },
      products: [
        {
          text: 'wSpy Pro - Mobile',
          value: 1,
        },
        {
          text: 'Netspy Pro',
          value: 2,
        },
        {
          text: 'Netspy Cloud',
          value: 3,
        }
      ],
      status: [
        {
          text: 'Ativo',
          value: 'ACTIVE'
        },
        {
          text: 'Inativo',
          value: 'INACTIVE'
        },
        {
          text: 'Oculto',
          value: 'HIDDEN'
        }
      ],
      statusNewCheckout: [
        {
          text: 'Ativo',
          value: 'ACTIVE'
        },
        {
          text: 'Inativo',
          value: 'INACTIVE'
        }
      ],
      intervals: [
        {
          text: 'Dia',
          value: 'DAY'
        },
        {
          text: 'Mês',
          value: 'MONTH'
        },
        {
          text: 'Ano',
          value: 'YEAR'
        }
      ],
      recurring: [
        {
          text: 'Sim',
          value: 'YES'
        },
        {
          text: 'Não',
          value: 'NO'
        }
      ],
      currencies: [
        {
          text: 'BRL',
          value: 'BRL'
        },
        {
          text: 'USD',
          value: 'USD'
        }
      ]
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      if (parseInt(this.$route.params.id) > 0) {
        this.$api
        .get(`/api/v1/backend/plano/${this.$route.params.id}`)
        .then((response) => {
          this.$vs.loading.close()
          this.data = response.data
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Erro',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
      }
    },
    save() {
      this.$vs.loading()

      this.$api({
        method: this.$route.params.id ? 'PATCH' : 'POST',
        url: this.$route.params.id ? `/api/v1/backend/plano/${this.$route.params.id}` : '/api/v1/backend/plano',
        data: this.data
      })
      .then((response) => {
        this.$vs.loading.close()
        this.data = response.data

        this.$vs.notify({
          text: 'Salvo',
          color: 'success'
        })

        this.$router.push('/planos')
      })
      .catch((error) => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Erro',
          text: Object.values(error.response.data.errors).join('<br>'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    }
  }
}
</script>
